import { BaseRouteService } from 'core/services';

class RegisterRouteService extends BaseRouteService {
    constructor() {
        super('register-users');
    }

    create(resource) {
        //sends activation email to registered users
        resource.mailUrl = window.location.origin;
        resource.sendEmailNotification = true;
        
        return super.create(this.base, resource);
    }
}

export default RegisterRouteService;
